(function ($, Drupal, drupalSettings) {

  var mbfSearchSitePageTextboxTimer;
  var mbfSearchAutocompleteTextboxTimer;
  var resultViewOnloadOnce = false;
  var stickySearchSidebar;
  var mbf404Retries = 0;

  Drupal.behaviors.mbf_search_001 = {
    attach: function (context) {

      function logClick(view, keywords, resourceLibrary, nid) {
        // Submit ajax call.
        $.ajax({
          type: 'POST',
          async: false,
          data: {
            'view': view,
            'keywords': keywords,
            'resource_category': resourceLibrary,
            'nid': nid,
          },
          dataType: 'json',
          url: drupalSettings.path.baseUrl + 'ajax/mbf-search/log-click'
        });
      } //-- logClick

      function facetsAjaxFixes() {
        return false;

        $('.block-facet-blocksearch-category').attr('id', 'block-searchcategory').attr('data-block-plugin-id', '').addClass('block-facets-ajax js-facet-block-id-searchcategory');
        $('.js-facets-checkbox-links.item-list__checkbox label[for="undefined"]').each(function(index, value){
          var id = 'allResults' + Math.random(1000, 9999);
          $(value).attr('for', id);
          $('input[type="checkbox"]', $(value).closest('.facet-item')).attr('id', id);
        });

        $('.block-facet-blockresource-library-category').attr('id', 'block-resourcelibrarycategory').addClass('block-facets-ajax js-facet-block-id-resourcelibrarycategory');
        $('.block-facet-blockresource-library-format').attr('id', 'block-resourcelibraryformat').addClass('block-facets-ajax js-facet-block-id-resourcelibraryformat');
      } //-- facetsAjaxFixes

      function resultViewOnloadClear() {
        if (!$('.block-facets-summary-blockmbf-resource-library-summary .facet-summary-item--clear a').length) {
          setTimeout(function () {
            resultViewOnloadClear();
          }, 100);
        } else {
          $('.resource-library-form .form-item').addClass('disabled');
          $('.resource-library-submit .mba-button').addClass('disabled');
          $('.block-facets-summary-blockmbf-resource-library-summary .facet-summary-item--clear a').trigger('click');
        }
      } //-- resultViewOnload

      function resultViewOnload() {
        if ($('#block-resourcelibrarycategory select').length && $('#block-resourcelibraryformat select').length) {
          if ($('#block-resourcelibrarycategory select option').index($('#block-resourcelibrarycategory select option:selected')) > 0 ||
              $('#block-resourcelibraryformat select option').index($('#block-resourcelibraryformat select option:selected')) > 0) {
            $('.mbm-button-001-wrapper.field__items div.field__item:first-of-type').hide();
            $('.mbm-button-001-wrapper.field__items div.field__item:last-of-type').show();
            $('.resource-library-cards').hide();
            $('.resource-library-results-sections').show();
            $('.resource-library-results').css('height', 'auto');
          }

          resultViewOnloadOnce = true;
        }

        if ($('.block-facet-blockresource-library-category .facet-empty').length && $('.block-facet-blockresource-library-format .facet-empty').length) {
          resultViewOnloadClear();

          resultViewOnloadOnce = true;
        }
      } //-- resultViewOnload

      function submitCardsSearch() {
        var category = $('.resource-library-form').data('cards-search-category');

        $('#block-resourcelibrarycategory select option').each(function(index, value){
          var decodedValue = decodeURIComponent($(value).attr('value'));
          if (decodedValue.indexOf(category) >= 0) {
            $('html, body').stop(true, true).animate({
              scrollTop: 0
            }, 400);
            $('#block-resourcelibrarycategory select').val($(value).attr('value')).trigger('change');
            $('.resource-library-submit .mbm-button-001-wrapper.field__items div.field__item:first-of-type a.mba-button').trigger('click');
          }
        });

      } //-- submitCardsSearch

      function checkCardsSearch() {
        if ($('body > .ajax-progress.ajax-progress-fullscreen').length) {
          setTimeout(function () {
            checkCardsSearch();
          }, 100);
        } else {
          submitCardsSearch();
        }
      } //-- extractResourceLibraryCategory

      function extractResourceLibraryCategory(url) {
        url = decodeURIComponent(url);

        if (url.indexOf('?') ) {
          url = url.split('?');
          url = url[1];
        }

        url = url.split('&');

        var category = '';
        jQuery.each(url, function(index, value){
          if (value.indexOf('=category:') >= 0) {
            category = value;
          }
        });

        return category;
      } //-- extractResourceLibraryCategory

      function triggerResourceLibraryCategorySearch(url) {
        // Get the facet querystring from the url.
        var category = extractResourceLibraryCategory(url);

        // Clear facets if any are set
        $('.resource-library-form .form-item').addClass('disabled');
        $('.resource-library-submit .mba-button').addClass('disabled');
        $('.block-facets-summary-blockmbf-resource-library-summary .facet-summary-item--clear a').trigger('click');

        // Add category to form data attribute to trogger by other function.
        $('.resource-library-form').data('cards-search-category', category);

        // Check if ajax is in progress, if not submit new search.
        checkCardsSearch();
      } //-- triggerResourceLibraryCategorySearch

      function hideShowSearchPageAutocomplete() {
        if (($('#mbf-search-site-page-textbox').is(':focus') || $('#mbf-search-site-gen-page-textbox').is(':focus')) &&
            $('.view-mbf-autocomplete.view-display-id-block_1 .views-row').length && $(window).outerWidth() >= 768) {
          if (!$('.view-mbf-autocomplete.view-display-id-block_1 .view-footer p span').length ||
              parseInt($('.view-mbf-autocomplete.view-display-id-block_1 .view-footer p span').text().trim()) < 5) {
            $('.view-mbf-autocomplete.view-display-id-block_1 .view-footer').hide();
          } else {
            $('.view-mbf-autocomplete.view-display-id-block_1 .view-footer').show();
          }
          if ($('#mbf-search-site-gen-page-textbox').is(':focus')) {
            $('.view-mbf-autocomplete.view-display-id-block_1').css('z-index', '1').css('left', '50%').hide().fadeTo(500, 1);
          } else {
            $('.view-mbf-autocomplete.view-display-id-block_1').css('z-index', '1').css('left', 'auto').hide().fadeTo(500, 1);
          }
        } else {
          $('.view-mbf-autocomplete.view-display-id-block_1').fadeTo(250, 0, 'linear', function(){
            $(this).css('z-index', '-1').css('left', '-9999px');
          });
        }
      } //-- hideShowSearchPageAutocomplete

      function hideShowSearchHeaderAutocomplete() {
        if ($('#mbf-search-autocomplete-textbox').is(':focus') && $('.view-mbf-autocomplete.view-display-id-block_2 .views-row').length && $(window).outerWidth() >= 768) {
          if (!$('.view-mbf-autocomplete.view-display-id-block_2 .view-footer p span').length ||
              parseInt($('.view-mbf-autocomplete.view-display-id-block_2 .view-footer p span').text().trim()) < 5) {
            $('.view-mbf-autocomplete.view-display-id-block_2 .view-footer').hide();
          } else {
            $('.view-mbf-autocomplete.view-display-id-block_2 .view-footer').show();
          }
          $('.view-mbf-autocomplete.view-display-id-block_2').css('z-index', '1').css('left', 'auto').hide().fadeTo(500, 1);
          $('.mbf-search-autocomplete-box-arrow').css('z-index', '2').css('left', '50%').hide().fadeTo(500, 1);
        } else {
          $('.view-mbf-autocomplete.view-display-id-block_2,.mbf-search-autocomplete-box-arrow').fadeTo(250, 0, 'linear', function(){
            $(this).css('z-index', '-1').css('left', '-9999px');
          });
        }
      } //-- hideShowSearchHeaderAutocomplete

      function facetsAccordion() {
        if ($('div[data-facet-id="facet_block:search_category"]').length) {
          if ($(window).outerWidth() <= 767 && !$('.facets-list-accordion').hasClass('hasAccordion')) {
            $('.facets-list-accordion .webform-submission-form').css('display', 'none');
            $('.facets-list-accordion').addClass('hasAccordion');
          } else if ($(window).outerWidth() > 767) {
            $('.facets-list-accordion .webform-submission-form').css('display', '');
            $('.facets-list-accordion').removeClass('hasAccordion');
            $('.facets-list-accordion-wrapper').removeClass('open').removeClass('opened');
          }
        }
      } //-- facetsAccordion

      function showNoFacetsOn404() {
        if (!$('body > .ajax-progress').length) {
          $('.view-mbf-site-search .views-exposed-form input[name="keywords"]').trigger('change');
        }

        if ($('body').hasClass('page-404') && $('.view-mbf-site-search .views-row').length && !$('div[data-facet-id="facet_block:search_category"] .facet-empty').length) {
          $('body').addClass('page-404-faceted');
        } else {
          mbf404Retries++;

          if (mbf404Retries < 25) {
            setTimeout(function () {
              showNoFacetsOn404();
            }, 100);
          }
        }
      } //-- showNoFacetsOn404

      function resourceLibraryButton1(element) {
        $('.resource-library-form .facets-widget-dropdown label.error').remove();
        var categorySelect = $('.resource-library-form .facets-widget-dropdown select[data-drupal-facet-id="resource_library_category"]');
        var formatSelect = $('.resource-library-form .facets-widget-dropdown select[data-drupal-facet-id="resource_library_format"]');
        if ($('option', categorySelect).index($('option:selected', categorySelect)) === 0 &&
          $('option', formatSelect).index($('option:selected', formatSelect)) === 0) {
          $('.resource-library-form .facets-widget-dropdown .select2').before('<label class="error"></label>');
          $('.resource-library-form .facets-widget-dropdown .select2').after('<label class="error">Please select an option</label>');
          return false;
        }

        $(element).closest('div.field__item').hide();
        $('.mbm-button-001-wrapper.field__items div.field__item:last-of-type').fadeIn();
        $('.resource-library-cards').slideUp(400);
        $('.resource-library-results-sections').slideDown(400);
        $('.resource-library-results').css('height', 'auto').slideDown(400, function(){
          $('html, body').stop(true, true).animate({
            scrollTop: 0
          }, 400);
        });
      } //-- resourceLibraryButton1

      function resourceLibraryButton2(element, triggerClick) {
        $(element).closest('div.field__item').hide();
        $('.mbm-button-001-wrapper.field__items div.field__item:first-of-type').fadeIn();
        $('.resource-library-cards').slideDown(400, function(){
          $('html, body').stop(true, true).animate({
            scrollTop: 0
          }, 400);
        });
        $('.resource-library-results-sections').slideUp(400);
        $('.resource-library-results').slideUp(400, function(){
          $(this).css('height', '0').show();
        });

        if (triggerClick) {
          $('.resource-library-form .form-item').addClass('disabled');
          $('.resource-library-submit .mba-button').addClass('disabled');
          $('.block-facets-summary-blockmbf-resource-library-summary .facet-summary-item--clear a').trigger('click');
        }
      } //-- resourceLibraryButton2

      function searchStickySidebarTopSpacing() {
        var topSpacing = 30;

        if (jQuery('#block-mbf-demo-theme-local-tasks').length) {
          topSpacing += jQuery('#block-mbf-demo-theme-local-tasks').position().top + jQuery('#block-mbf-demo-theme-local-tasks').outerHeight();
        }

        if ($('#page > header .region-header').hasClass('fixed-position-show')) {
          topSpacing += parseInt($('#page > header').outerHeight());
        }

        if ($('body').hasClass('user-logged-in') && ($('body').hasClass('toolbar-fixed') || $(window).scrollTop() == 0)) {
          topSpacing += $('#toolbar-administration > #toolbar-bar').outerHeight();
          topSpacing += $('#toolbar-item-administration-tray.toolbar-tray-horizontal').is(':visible') ? $('#toolbar-item-administration-tray').outerHeight() : 0;
          topSpacing += $('.region-local-tasks').length ? $('.region-local-tasks').outerHeight() : 0;
        }

        if (topSpacing !== stickySearchSidebar.options.topSpacing) {
          stickySearchSidebar.options.topSpacing = topSpacing;
          stickySearchSidebar.updateSticky();
        }
      } //-- searchStickySidebarTopSpacing

      // ==========================================

      // Add hide/show class to form section parents.
      $('.resource-library-results-hidden:not(.resource-library-results)').closest('.mbf-page--section').addClass('resource-library-results-sections');
      $('.resource-library-results-sections .resource-library-results-hidden').show();

      // Result click handler to log click.
      $('body:not(.page-404)').once('mbf_search_001_site_search_page_result_click_log').on('click', '.view-mbf-site-search.view-display-id-block_1 .search-result-row .views-field-title a', function(){
        var keywords = $('.view-mbf-site-search.view-display-id-block_1 .views-exposed-form input[name="keywords"]').val();
        var nid = $('.view-row-nid ', $(this).closest('.views-row')).data('nid');
        logClick('mbf-site-search (search page)', keywords, null, nid);
      });
      $('body.page-404').once('mbf_search_001_site_search_404_result_click_log').on('click', '.view-mbf-site-search.view-display-id-block_1 .search-result-row .views-field-title a', function(){
        var keywords = $('.view-mbf-site-search.view-display-id-block_1 .views-exposed-form input[name="keywords"]').val();
        var nid = $('.view-row-nid ', $(this).closest('.views-row')).data('nid');
        logClick('mbf-site-search (404 page)', keywords, null, nid);
      });
      $('body:not(.page-404)').once('mbf_search_001_autocomplete_search_page_result_click_log').on('click', '.view-mbf-autocomplete.view-display-id-block_1 .autocomplete-row .views-field-title a', function(){
        var keywords = $('.view-mbf-site-search.view-display-id-block_1 .views-exposed-form input[name="keywords"]').val();
        var nid = $('.view-row-nid ', $(this).closest('.views-row')).data('nid');
        logClick('mbf-autocomplete (search page)', keywords, null, nid);
      });
      $('body.page-404').once('mbf_search_001_autocomplete_404_page_result_click_log').on('click', '.view-mbf-autocomplete.view-display-id-block_1 .autocomplete-row .views-field-title a', function(){
        var keywords = $('.view-mbf-autocomplete.view-display-id-block_1 .views-exposed-form input[name="keywords"]').val();
        var nid = $('.view-row-nid ', $(this).closest('.views-row')).data('nid');
        logClick('mbf-autocomplete (404 page)', keywords, null, nid);
      });
      $('body').once('mbf_search_001_autocomplete_header_result_click_log').on('click', '.view-mbf-autocomplete.view-display-id-block_2 .autocomplete-row .views-field-title a', function(){
        var keywords = $('.view-mbf-autocomplete.view-display-id-block_2 .views-exposed-form input[name="keywords"]').val();
        var nid = $('.view-row-nid ', $(this).closest('.views-row')).data('nid');
        logClick('mbf-autocomplete (header)', keywords, null, nid);
      });
      $('body').once('mbf_search_001_resource_library_result_click_log').on('click', '.view-mbf-resource-library .search-result-row .views-field-title a', function(){
        var resourceLibrary = $('.block-facet-blockresource-library-category .item-list__dropdown li.facet-item .is-active').data('drupal-facet-item-value');
        var nid = $('.view-row-nid ', $(this).closest('.views-row')).data('nid');
        logClick('mbf-resource-library', null, resourceLibrary, nid);
      });

      // Hacks to fix facets ajax.
      facetsAjaxFixes();

      // Delay Views ajax updated while still typing, blur view during delay.
      $('#mbf-search-site-page-textbox,#mbf-search-site-gen-page-textbox').once('mbf-search-site-page-textbox-clear').val($('#mbf-search-site-page-textbox').attr('value'));
      $('body').once('mbf-search-site-page-textbox-triggers').on('change keyup paste', '#mbf-search-site-page-textbox,#mbf-search-site-gen-page-textbox', function(e){
        // If its less than tablet, don't do the autocomplete.
        if ($(window).outerWidth() < 768) {
          return true;
        }

        // On change, check its not already done by keyup
        if (e.type === 'change' && $(this).val() === $('.view-mbf-autocomplete.view-display-id-block_1 .views-exposed-form input[name="keywords"]').val()) {
          return true;
        }

        // Ignore enter/submit.
        var keycode = (event.keyCode ? event.keyCode : event.which);
        if (keycode === '13') {
          return true;
        }

        // Clear typing timer and set a delay if the event is a keyup.
        clearTimeout(mbfSearchSitePageTextboxTimer);
        var delay = 0;
        if (e.type === 'keyup') {
          delay = 500;
        }

        $('.view-mbf-autocomplete.view-display-id-block_1 .autocomplete-row,.view-mbf-autocomplete.view-display-id-block_1 .view-footer').addClass('blurred');

        // Update view form and submit, on delay if a keyup.
        mbfSearchSitePageTextboxTimer = setTimeout(function(){
          var newVal = $('#mbf-search-site-page-textbox,#mbf-search-site-gen-page-textbox').val();
          if (newVal.length < 3) {
            newVal = '';
          }
          if ($('.view-mbf-autocomplete.view-display-id-block_1 .views-exposed-form input[name="keywords"]').val() !== newVal) {
            $('.view-mbf-autocomplete.view-display-id-block_1 .views-exposed-form input[name="keywords"]').val(newVal).trigger('change');
          }
        }, delay);
      });

      // Update page results.
      $('body').once('mbf-search-site-page-form').on('submit', '#mbf-search-site-page-form', function(){
        $('input:focus').blur();

        var newVal = $('#mbf-search-site-page-textbox').val();
        if (newVal.length < 3) {
          newVal = '';
        }
        if ($('.view-mbf-site-search .views-exposed-form input[name="keywords"]').val() !== newVal) {
          $('.view-mbf-site-search .views-exposed-form input[name="keywords"]').val(newVal).trigger('change');
        }

        return false;
      });

      // Delay Views ajax updated while still typing, blur view during delay.
      $('#mbf-search-autocomplete-textbox').once('mbf-search-autocomplete-textbox-clear').val($('#mbf-search-autocomplete-textbox').attr('value'));
      $('body').once('mbf-search-autocomplete-textbox-triggers').on('change keyup paste', '#mbf-search-autocomplete-textbox', function(e){
        // If its less than tablet, don't do the autocomplete.
        if ($(window).outerWidth() < 768) {
          return true;
        }

        // On change, check its not already done by keyup
        if (e.type === 'change' && $(this).val() === $('.view-mbf-autocomplete.view-display-id-block_2 .views-exposed-form input[name="keywords"]').val()) {
          return true;
        }

        // Clear typing timer and set a delay if the event is a keyup.
        clearTimeout(mbfSearchAutocompleteTextboxTimer);
        var delay = 0;
        if (e.type === 'keyup') {
          delay = 500;
        }

        $('.view-mbf-autocomplete.view-display-id-block_2 .autocomplete-row,.view-mbf-autocomplete.view-display-id-block_2 .view-footer').addClass('blurred');

        // Update view form and submit, on delay if a keyup.
        mbfSearchAutocompleteTextboxTimer = setTimeout(function(){
          var newVal = $('#mbf-search-autocomplete-textbox').val();
          if (newVal.length < 3) {
            newVal = '';
          }
          if ($('.view-mbf-autocomplete.view-display-id-block_2 .views-exposed-form input[name="keywords"]').val() !== newVal) {
            $('.view-mbf-autocomplete.view-display-id-block_2 .views-exposed-form input[name="keywords"]').val(newVal).trigger('change');
          }
        }, delay);
      });

      // Resource library buttons.
      $('body').once('mbf-resource-library-button-first').on('click', '.resource-library-submit .mbm-button-001-wrapper.field__items div.field__item:first-of-type a.mba-button', function(){
        resourceLibraryButton1(this);
        return false;
      });
      $('body').once('mbf-resource-library-button-last').on('click', '.resource-library-submit .mbm-button-001-wrapper.field__items div.field__item:last-of-type a.mba-button', function(){
        resourceLibraryButton2(this, true);
        return false;
      });

      // Reset form if both filters are cleared, or clear select errors on change.
      $('body').once('mbf-resource-library-selects-changed').on('change', '.resource-library-form .facets-widget-dropdown select', function(){
        var categorySelect = $('.resource-library-form .facets-widget-dropdown select[data-drupal-facet-id="resource_library_category"]');
        var formatSelect = $('.resource-library-form .facets-widget-dropdown select[data-drupal-facet-id="resource_library_format"]');
        if ($('option', categorySelect).index($('option:selected', categorySelect)) === 0 &&
            $('option', formatSelect).index($('option:selected', formatSelect)) === 0) {
          resourceLibraryButton2($('.resource-library-submit .mbm-button-001-wrapper.field__items div.field__item:last-of-type a.mba-button'), false);
        }
        if ($('option', categorySelect).index($('option:selected', categorySelect)) !== 0 ||
          $('option', formatSelect).index($('option:selected', formatSelect)) !== 0) {
          $('.resource-library-form label.error').remove();
        }

        $('.resource-library-form .form-item').addClass('disabled');
        $('.resource-library-submit .mba-button').addClass('disabled');
      });

      // Trigger video popup.
      $('body').once('mbf_search_001_result_click_video').on('click', '.search-result-row .views-field-title a', function(){
        if ($(this).attr('href') === '#' &&
            $('.views-field-field-video', $(this).closest('.views-row')).length) {
          $('.views-field-field-video .paragraph-type-mba-media-002 .field-name-video-thumbnail-image', $(this).closest('.views-row')).trigger('click');
          return false;
        }
      });

      // Convert dropdown facets to select2.
      $('.facets-widget-dropdown select:not(.select2-hidden-accessible)').each(function(i, value) {
        $(value).select2({
          placeholder: $('option:first', value).text(),
          allowClear: true,
          dropdownPosition: 'below'
        });
      });

      // If loaded with facet querystring, switch to results view.
      if ($('.resource-library-form').length) {
        if (!resultViewOnloadOnce) {
          resultViewOnload();
        }
      }

      // Trigger a search by clicking the cards.
      if ($('.resource-library-cards').length) {
        $('body').once('resource-library-cards-click').on('click', '.resource-library-cards a.mba-button', function(){
          triggerResourceLibraryCategorySearch($(this).attr('href'));
          return false;
        });
      }

      // Show/hide the autocompletes.
      $('body').once('mbf-search-site-page-textbox-focus-blur').on('focus blur', '#mbf-search-site-page-textbox,#mbf-search-site-gen-page-textbox', function(){
        $(this).attr('autocomplete', 'off');
        hideShowSearchPageAutocomplete();
      });
      $('body').once('mbf-search-autocomplete-textbox-focus-blur').on('focus blur', '#mbf-search-autocomplete-textbox', function(){
        $(this).attr('autocomplete', 'off');
        hideShowSearchHeaderAutocomplete();
      });
      hideShowSearchPageAutocomplete();
      hideShowSearchHeaderAutocomplete();

      // Prevent empty searching.
      $('body').once('mbf-search-form-submits').on('submit', 'form#mbf-search-autocomplete-form,form#mbf-search-gen-site-page-form', function(){
        if ($('input[type="text"]', $(this)).val() === '') {
          return false;
        }
      });

      // Show correct no results message.
      $('.view-mbf-site-search .views-exposed-form input[name="keywords"]').once('mbf-search-autocomplete-textbox-clear').val($('.view-mbf-site-search .views-exposed-form input[name="keywords"]').attr('value'));
      $('.mbf-search-results').removeClass('no-results').removeClass('no-keywords');
      if ($('.view-mbf-site-search .view-empty').length && !$('.view-mbf-site-search .views-row').length &&
          $('.view-mbf-site-search .views-exposed-form input[name="keywords"]').val() !== '')
      {
        $('.mbf-search-results').addClass('no-results');
      } else if ($('.view-mbf-site-search .view-empty').length && !$('.view-mbf-site-search .views-row').length &&
          $('.view-mbf-site-search .views-exposed-form input[name="keywords"]').val() === '')
      {
        $('.mbf-search-results').addClass('no-keywords');
      }

      // Update facets on 404.
      if ($('body').hasClass('page-404') && $('.view-mbf-site-search .views-row').length && $('div[data-facet-id="facet_block:search_category"] .facet-empty').length && !$('body > .ajax-progress').length) {
        showNoFacetsOn404();
      }

      // Set search page section as faceted for sidebar transitions.
      $('.mbf-search-results').once('mbf-search-results-faceted').addClass('mbf-search-results-faceted');

      // Add a fake caret to the search input box.
      if (!$('#search-input__ghost').length) {
        fakeCaretInit('#mbf-search-site-page-textbox', '.search-input__caret-container span',  '.search-input__caret');
      }

      // Update checkboxes facets count.
      $('div[data-facet-id="facet_block:search_category"] .facets-narrow').each(function (index, value){
        $('strong', value).text($('li.facets-reset label .facet-item__count', $(value).closest('.facets-widget-checkbox')).text().replace(/\D/g,'') + ' results ');
      });

      // Facets list as lis for desktop and tablet, accordion on mobile.
      facetsAccordion();
      if (!$('div[data-facet-id="facet_block:search_category"] .facets-narrow').hasClass('initAccordion')) {
        $('div[data-facet-id="facet_block:search_category"] .facets-narrow').addClass('initAccordion').mbf_accordion( {
          accordionItem: '.facets-list-accordion-wrapper',
          slideElement: '.webform-submission-form',
          icon: true,
          iconElement: '.facets-list-accordion-wrapper',
          parentItem: '.facets-list-accordion-wrapper',
          containerItem: '.facets-list-accordion',
          maxWidth: 767,
        });
      }
      $(window).resize(function() {
        facetsAccordion();
      });

      // Fix facets if they just updated.
      if ($('.facets-list-accordion .webform-submission-form').is(':visible') &&
          $('.facets-list-accordion').hasClass('hasAccordion') &&
          !$('.facets-list-accordion-wrapper').hasClass('open')) {
        $('.facets-list-accordion .webform-submission-form').hide();
      }

      // Sticky sidebar.
      if ($('.mbf-search-results').length && !$('#sticky-search-sidebar').length) {
        $('.mbf-search-results > .row > .col-xl-4').wrapInner('<div id="sticky-search-sidebar"><div id="sticky-search-sidebar-inner"></div></div>');
        stickySearchSidebar = new StickySidebar('#sticky-search-sidebar', {
          topSpacing: 30,
          bottomSpacing: 30,
          containerSelector: '.mbf-search-results > .row',
          innerWrapperSelector: '#sticky-search-sidebar-inner',
          minWidth: 992
        });

        $(window).on('resize scroll', function () {
          searchStickySidebarTopSpacing();
          setTimeout(function () {
            searchStickySidebarTopSpacing();
          }, 300);
        });
      }
      if ($('.mbf-search-results').length) {
        searchStickySidebarTopSpacing();
      }

      // In page mini search block.
      if ($('#mbf-search-site-gen-page-textbox').length && !$('.mbf-search-autocomplete.mbf-search-autocomplete-genpage').length) {
        $('#mbf-search-site-gen-page-textbox').closest('.layout--mbf-col-section').addClass('mbf-search-autocomplete').addClass('mbf-search-autocomplete-onload').addClass('mbf-search-autocomplete-genpage');
        $('#mbf-search-site-gen-page-textbox').once('mbf-search-site-gen-page-focusing').focus(function(){
          $(this).closest('form').addClass('focusing');
        }).blur(function(){
          $(this).closest('form').removeClass('focusing');
        });
      }

      // Remove class to stop hiding autocompleters.
      if  ($('.mbf-search-autocomplete-onload .view-mbf-autocomplete').length) {
        $('.mbf-search-autocomplete-onload .view-mbf-autocomplete').each(function (index, value){
          $(value).closest('.mbf-search-autocomplete').removeClass('mbf-search-autocomplete-onload');
        });
      }

      // Re-enable buttons after factes updates.
      if (!$('.resource-library-form .form-item.disabled').length) {
        $('.resource-library-submit .mba-button').removeClass('disabled');
      }

      // Open and close hidden search.
      $('.hidden-search a[href*="/search"]').once('mbf-search-site-hidden-search-open').click(function (e) {
        $('#mbf-search-autocomplete-form').addClass('opened');
        $('#mbf-search-autocomplete-form input[type="text"]').focus();
        e.preventDefault();
      });
      $('.hidden-search span.closer-search').once('mbf-search-site-hidden-search-close').click(function () {
        $('#mbf-search-autocomplete-form').removeClass('opened');
      });

    },
  };

})(jQuery, Drupal, drupalSettings);
